import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { StudiesService } from 'src/app/shared/services/studies.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { LoginService } from 'src/app/services/login.service';
import { surveyPanelService } from 'src/app/serveypanel/survey-panel-service/survey-panel.service';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-create-study',
  templateUrl: './create-study.component.html',
  styleUrls: ['./create-study.component.scss']
})
export class CreateStudyComponent implements OnInit {
@Output()updateStudy = new EventEmitter<boolean>();
  studyName =  new FormControl('');
  projectId:string;
  studyStatus :boolean = false;
  studytype:number=1;
  // survey_id:string = '';
  survey_id = new FormControl();
  public search:string = '';
  accessRole:any;
  
  // filteredOptions: Observable<string[]>;
  public surveyList:any = [];
  public filteredSurveyList:any = [];
  // public surveyList:any[] = [
  //   {
  //     "survey": {
  //       "id": 8890,
  //       "uuid": null,
  //       "name": "Wander 2022 - Kantar || Jan",
  //       "api_survey_id": 8860,
  //       "misc_property": "{\"client\":\"Hindustan Thompson Associates Private Limited(Kantar)\",\"category\":\"tours_nd_travels\",\"research_type\":\"brand_track\",\"account_type\":\"Agency\",\"river_pct\":\"0\",\"panel_pct\":\"100\",\"paid\":\"paid\",\"study_type\":\"Brand_Performance\",\"study_sub_type\":\"Brand_Health_Tracking\",\"pm\":\"Diksha\",\"ss\":\"250\",\"cpi\":\"394\",\"deadline\":\"2022-01-28\",\"crm_id\":\"C-10301\",\"loi\":\"20\",\"study_execution_type\":\"\"}",
  //       "login_user_id": 1552,
  //       "status": 0,
  //       "createdAt": "2022-01-07T10:49:16.000Z",
  //       "updatedAt": "2022-01-07T10:49:46.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "diksha.kundra@crownit.in",
  //       "projectName": null,
  //       "studyName": null,
  //       "orgName": null,
  //       "updateBy": null
  //     },
  //     "dateCreated": "07-Jan-2022",
  //     "responseCount": 1,
  //     "questionCount": 9
  //   },
  //   {
  //     "survey": {
  //       "id": 8889,
  //       "uuid": null,
  //       "name": "Fragnance test",
  //       "api_survey_id": 8859,
  //       "misc_property": null,
  //       "login_user_id": 949,
  //       "status": 0,
  //       "createdAt": "2022-01-07T10:44:26.000Z",
  //       "updatedAt": "2022-01-07T10:44:26.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "kunal.yadav@crownit.in",
  //       "projectName": null,
  //       "studyName": null,
  //       "orgName": null,
  //       "updateBy": null
  //     },
  //     "dateCreated": "07-Jan-2022",
  //     "responseCount": 0,
  //     "questionCount": 10
  //   },
  //   {
  //     "survey": {
  //       "id": 8888,
  //       "uuid": null,
  //       "name": "QA_AUTO_CODE_dest",
  //       "api_survey_id": 8858,
  //       "misc_property": "{\"survey_type\":\"4\",\"page_number\":\"0\",\"page_text\":\"\",\"state_targeting\":\"0\",\"study_mode\":\"quant\",\"no_of_interviews\":\"\",\"smart_comm\":\"0\",\"pixel\":\"0\",\"recruiter_restart\":\"0\",\"show_overlay\":\"only-on-top\",\"overlay_position\":\"top-left\",\"agency_pixel\":\"0\",\"referral_reward_limit\":\"500\",\"delayed_terminate\":\"0\",\"delayed_category\":\"0\",\"red_user_state\":0,\"user_restriction\":\"\",\"rer_block_survey_on\":[],\"cookies_days\":\"365\",\"cookies_time\":\"1\",\"entry_days\":\"365\",\"language\":0,\"paytm_check\":\"2\",\"paytm_check_interval\":\"1\",\"survey_ids\":\"8858\",\"callback_url_status\":\"2\",\"launch_date\":\"2022-01-07 15:12:54\",\"survey_state\":1,\"survey_time\":21,\"time_breakup\":{\"244211\":1,\"244214\":1,\"244217\":1,\"244219\":1,\"244234\":3,\"244235\":1,\"244237\":1,\"244239\":2,\"244240\":3,\"244260\":1,\"244264\":6}}",
  //       "login_user_id": 767,
  //       "status": 1,
  //       "createdAt": "2022-01-07T09:26:11.000Z",
  //       "updatedAt": "2022-01-07T09:26:11.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "aljozy.bazer@crownit.in",
  //       "projectName": null,
  //       "studyName": null,
  //       "orgName": null,
  //       "updateBy": null
  //     },
  //     "dateCreated": "07-Jan-2022",
  //     "responseCount": 6,
  //     "questionCount": 11
  //   },
  //   {
  //     "survey": {
  //       "id": 8887,
  //       "uuid": null,
  //       "name": "qa_auto_code_source",
  //       "api_survey_id": 8857,
  //       "misc_property": "{\"survey_type\":\"4\",\"page_number\":\"0\",\"page_text\":\"\",\"state_targeting\":\"0\",\"study_mode\":\"quant\",\"no_of_interviews\":\"\",\"smart_comm\":\"0\",\"pixel\":\"0\",\"recruiter_restart\":\"0\",\"show_overlay\":\"only-on-top\",\"overlay_position\":\"top-left\",\"agency_pixel\":\"0\",\"referral_reward_limit\":\"500\",\"delayed_terminate\":\"0\",\"delayed_category\":\"0\",\"red_user_state\":0,\"user_restriction\":\"\",\"rer_block_survey_on\":[],\"cookies_days\":\"365\",\"cookies_time\":\"1\",\"entry_days\":\"365\",\"language\":0,\"paytm_check\":\"2\",\"paytm_check_interval\":\"1\",\"survey_ids\":\"8857\",\"callback_url_status\":\"2\",\"launch_date\":\"2022-01-07 15:10:04\",\"survey_state\":1,\"survey_time\":7,\"time_breakup\":{\"244192\":1,\"244201\":3,\"244202\":1,\"244205\":1,\"244208\":1}}",
  //       "login_user_id": 767,
  //       "status": 1,
  //       "createdAt": "2022-01-07T09:17:24.000Z",
  //       "updatedAt": "2022-01-07T09:17:24.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "aljozy.bazer@crownit.in",
  //       "projectName": null,
  //       "studyName": null,
  //       "orgName": null,
  //       "updateBy": null
  //     },
  //     "dateCreated": "07-Jan-2022",
  //     "responseCount": 1,
  //     "questionCount": 5
  //   },
  //   {
  //     "survey": {
  //       "id": 8886,
  //       "uuid": null,
  //       "name": "Project Mercury- Nielsen",
  //       "api_survey_id": 8856,
  //       "misc_property": null,
  //       "login_user_id": 1638,
  //       "status": 0,
  //       "createdAt": "2022-01-07T09:17:11.000Z",
  //       "updatedAt": "2022-01-07T09:17:11.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "heena.gaur@crownit.in",
  //       "projectName": null,
  //       "studyName": null,
  //       "orgName": null,
  //       "updateBy": null
  //     },
  //     "dateCreated": "07-Jan-2022",
  //     "responseCount": 0,
  //     "questionCount": 9
  //   },
  //   {
  //     "survey": {
  //       "id": 8885,
  //       "uuid": null,
  //       "name": "Affinity one questionnaire Survey",
  //       "api_survey_id": 8855,
  //       "misc_property": null,
  //       "login_user_id": 1563,
  //       "status": 0,
  //       "createdAt": "2022-01-07T07:58:14.000Z",
  //       "updatedAt": "2022-01-07T07:58:14.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "dhurbo.sinha@crownit.in",
  //       "projectName": null,
  //       "studyName": null,
  //       "orgName": null,
  //       "updateBy": null
  //     },
  //     "dateCreated": "07-Jan-2022",
  //     "responseCount": 16,
  //     "questionCount": 6
  //   },
  //   {
  //     "survey": {
  //       "id": 8884,
  //       "uuid": null,
  //       "name": "Dove Dafoe Bangalore -  Mandate",
  //       "api_survey_id": 8854,
  //       "misc_property": null,
  //       "login_user_id": 1552,
  //       "status": 0,
  //       "createdAt": "2022-01-07T07:08:19.000Z",
  //       "updatedAt": "2022-01-07T07:08:42.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "diksha.kundra@crownit.in",
  //       "projectName": null,
  //       "studyName": null,
  //       "orgName": null,
  //       "updateBy": null
  //     },
  //     "dateCreated": "07-Jan-2022",
  //     "responseCount": 4,
  //     "questionCount": 7
  //   },
  //   {
  //     "survey": {
  //       "id": 8883,
  //       "uuid": null,
  //       "name": "Dove Dafoe Bangalore - Non  Mandate",
  //       "api_survey_id": 8853,
  //       "misc_property": "{\"client\":\"Hindustan Thompson Associates Private Limited(Kantar)\",\"category\":\"soap_cakes_bars\",\"research_type\":\"Link\",\"account_type\":\"Agency\",\"river_pct\":\"20\",\"panel_pct\":\"80\",\"paid\":\"paid\",\"study_type\":\"Marketing_Communication_Evaluation\",\"study_sub_type\":\"Campaign_Evaluation\",\"pm\":\"Diksha\",\"ss\":\"52\",\"cpi\":\"192\",\"deadline\":\"2022-01-10\",\"crm_id\":\"C-10178\",\"loi\":\"15\",\"study_execution_type\":\"\"}",
  //       "login_user_id": 1552,
  //       "status": 0,
  //       "createdAt": "2022-01-07T07:06:01.000Z",
  //       "updatedAt": "2022-01-07T07:06:39.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "diksha.kundra@crownit.in",
  //       "projectName": null,
  //       "studyName": null,
  //       "orgName": null,
  //       "updateBy": null
  //     },
  //     "dateCreated": "07-Jan-2022",
  //     "responseCount": 1,
  //     "questionCount": 7
  //   },
  //   {
  //     "survey": {
  //       "id": 8882,
  //       "uuid": null,
  //       "name": "Project Mercury- Nielsen",
  //       "api_survey_id": 8852,
  //       "misc_property": null,
  //       "login_user_id": 1638,
  //       "status": 0,
  //       "createdAt": "2022-01-07T06:51:41.000Z",
  //       "updatedAt": "2022-01-07T06:51:41.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "heena.gaur@crownit.in",
  //       "projectName": null,
  //       "studyName": null,
  //       "orgName": null,
  //       "updateBy": null
  //     },
  //     "dateCreated": "07-Jan-2022",
  //     "responseCount": 1,
  //     "questionCount": 6
  //   },
  //   {
  //     "survey": {
  //       "id": 8881,
  //       "uuid": null,
  //       "name": "Project Fresh 2: C- 9708",
  //       "api_survey_id": 8851,
  //       "misc_property": null,
  //       "login_user_id": 582,
  //       "status": 0,
  //       "createdAt": "2022-01-07T06:22:46.000Z",
  //       "updatedAt": "2022-01-07T06:23:19.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "yash.tyagi@crownit.in",
  //       "projectName": null,
  //       "studyName": null,
  //       "orgName": null,
  //       "updateBy": null
  //     },
  //     "dateCreated": "07-Jan-2022",
  //     "responseCount": 1,
  //     "questionCount": 45
  //   },
  //   {
  //     "survey": {
  //       "id": 8880,
  //       "uuid": null,
  //       "name": "C-9243 Project Spring | POST LAUNCH",
  //       "api_survey_id": 8850,
  //       "misc_property": null,
  //       "login_user_id": 1566,
  //       "status": 0,
  //       "createdAt": "2022-01-07T06:14:34.000Z",
  //       "updatedAt": "2022-01-07T07:16:26.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "sarika.tiwari@crownit.in",
  //       "projectName": null,
  //       "studyName": null,
  //       "orgName": null,
  //       "updateBy": null
  //     },
  //     "dateCreated": "07-Jan-2022",
  //     "responseCount": 6,
  //     "questionCount": 41
  //   },
  //   {
  //     "survey": {
  //       "id": 8879,
  //       "uuid": null,
  //       "name": "PJ Showman",
  //       "api_survey_id": 8849,
  //       "misc_property": null,
  //       "login_user_id": 1596,
  //       "status": 0,
  //       "createdAt": "2022-01-07T06:05:57.000Z",
  //       "updatedAt": "2022-01-07T06:05:57.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "rohit.yadav@crownit.in",
  //       "projectName": null,
  //       "studyName": null,
  //       "orgName": null,
  //       "updateBy": null
  //     },
  //     "dateCreated": "07-Jan-2022",
  //     "responseCount": 3,
  //     "questionCount": 33
  //   },
  //   {
  //     "survey": {
  //       "id": 8878,
  //       "uuid": null,
  //       "name": "PURPLLE SHORT QNR",
  //       "api_survey_id": 8848,
  //       "misc_property": "{\"client\":\"Internal- Crownit\",\"category\":\"e_commerce\",\"research_type\":\"incidence_check\",\"account_type\":\"Brand\",\"river_pct\":\"10\",\"panel_pct\":\"90\",\"paid\":\"unpaid\",\"study_type\":\"Shopper_Insights\",\"study_sub_type\":\"Incidence\",\"pm\":\"Sanyukta sachdeva\",\"ss\":\"0\",\"cpi\":\"0\",\"deadline\":\"2022-01-20\",\"crm_id\":\"C-10259\",\"loi\":\"45\",\"study_execution_type\":\"\",\"survey_type\":\"1\",\"page_number\":\"0\",\"page_text\":\"\",\"state_targeting\":\"0\",\"study_mode\":\"qual\",\"no_of_interviews\":\"50\",\"smart_comm\":\"0\",\"pixel\":\"0\",\"recruiter_restart\":\"0\",\"show_overlay\":\"only-on-top\",\"overlay_position\":\"top-left\",\"agency_pixel\":\"0\",\"referral_reward_limit\":\"500\",\"delayed_terminate\":\"0\",\"delayed_category\":\"0\",\"red_user_state\":0,\"user_restriction\":{\"study_type\":{\"element\":[\"RQ\"],\"days\":\"7\"}},\"rer_block_survey_on\":[],\"cookies_days\":\"365\",\"cookies_time\":\"1\",\"entry_days\":\"365\",\"language\":0,\"paytm_check\":\"1\",\"paytm_check_interval\":\"1\",\"survey_ids\":\"8848\",\"callback_url_status\":\"2\",\"launch_date\":\"2022-01-07 13:14:07\",\"survey_state\":1,\"survey_time\":40,\"time_breakup\":{\"243868\":3,\"243869\":1,\"243872\":6,\"243873\":1,\"243874\":1,\"243875\":1,\"243879\":3,\"243882\":1,\"243885\":5,\"243888\":1,\"243891\":3,\"243894\":1,\"243895\":4,\"243969\":1,\"243970\":4,\"243971\":3,\"243972\":1}}",
  //       "login_user_id": 278,
  //       "status": 1,
  //       "createdAt": "2022-01-07T05:23:09.000Z",
  //       "updatedAt": "2022-01-07T05:23:09.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "sanyuktasachdeva@crownit.in",
  //       "projectName": "PURPLLE SHORT QNR",
  //       "studyName": "PURPLLE SHORT QNR",
  //       "orgName": "Crownit",
  //       "updateBy": null
  //     },
  //     "dateCreated": "07-Jan-2022",
  //     "responseCount": 338,
  //     "questionCount": 17
  //   },
  //   {
  //     "survey": {
  //       "id": 8877,
  //       "uuid": null,
  //       "name": "Education Tech Edutech - Dip",
  //       "api_survey_id": 8847,
  //       "misc_property": "{\"client\":\"Crownit\",\"category\":\"electronics\",\"research_type\":\"Ad_Evaluation\",\"account_type\":\"Brand\",\"river_pct\":\"20\",\"panel_pct\":\"80\",\"paid\":\"paid\",\"study_type\":\"Brand_Performance\",\"study_sub_type\":\"Brand_Health_Tracking\",\"pm\":\"Ajitesh Pal Singh\",\"ss\":\"0\",\"cpi\":\"0\",\"deadline\":\"2022-05-31\",\"crm_id\":\"C-4789\",\"loi\":\"\",\"study_execution_type\":\"\",\"survey_type\":\"1\",\"page_number\":\"0\",\"page_text\":\"\",\"state_targeting\":\"0\",\"study_mode\":\"quant\",\"no_of_interviews\":\"\",\"smart_comm\":\"0\",\"pixel\":\"0\",\"recruiter_restart\":\"0\",\"show_overlay\":\"only-on-top\",\"overlay_position\":\"top-left\",\"agency_pixel\":\"0\",\"referral_reward_limit\":\"500\",\"delayed_terminate\":\"0\",\"delayed_category\":\"0\",\"red_user_state\":0,\"user_restriction\":\"\",\"rer_block_survey_on\":[],\"cookies_days\":\"365\",\"cookies_time\":\"1\",\"entry_days\":\"365\",\"language\":0,\"paytm_check\":\"1\",\"paytm_check_interval\":\"1\",\"survey_ids\":\"8847\",\"callback_url_status\":\"2\",\"launch_date\":\"2022-01-07 11:38:35\",\"survey_state\":2,\"survey_time\":26,\"time_breakup\":{\"243863\":1,\"243864\":1,\"243865\":3,\"243876\":1,\"243881\":1,\"243921\":4,\"243923\":4,\"243924\":6,\"243925\":5}}",
  //       "login_user_id": 769,
  //       "status": 0,
  //       "createdAt": "2022-01-07T05:17:40.000Z",
  //       "updatedAt": "2022-01-07T05:17:40.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "ajitesh.singh@crownit.in",
  //       "projectName": "Education Tech Edutech - Dip",
  //       "studyName": "Education Tech Edutech - Dip",
  //       "orgName": "Crownit",
  //       "updateBy": null
  //     },
  //     "dateCreated": "07-Jan-2022",
  //     "responseCount": 527,
  //     "questionCount": 9
  //   },
  //   {
  //     "survey": {
  //       "id": 8876,
  //       "uuid": null,
  //       "name": "Amazon purple short qnr",
  //       "api_survey_id": 8846,
  //       "misc_property": null,
  //       "login_user_id": 1563,
  //       "status": 0,
  //       "createdAt": "2022-01-07T04:43:46.000Z",
  //       "updatedAt": "2022-01-07T05:20:54.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "dhurbo.sinha@crownit.in",
  //       "projectName": null,
  //       "studyName": null,
  //       "orgName": null,
  //       "updateBy": null
  //     },
  //     "dateCreated": "07-Jan-2022",
  //     "responseCount": 1,
  //     "questionCount": 1
  //   },
  //   {
  //     "survey": {
  //       "id": 8873,
  //       "uuid": null,
  //       "name": "Question type demo survey",
  //       "api_survey_id": 8843,
  //       "misc_property": null,
  //       "login_user_id": 582,
  //       "status": 0,
  //       "createdAt": "2022-01-06T14:49:52.000Z",
  //       "updatedAt": "2022-01-06T14:51:14.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "yash.tyagi@crownit.in",
  //       "projectName": null,
  //       "studyName": null,
  //       "orgName": null,
  //       "updateBy": null
  //     },
  //     "dateCreated": "06-Jan-2022",
  //     "responseCount": 3,
  //     "questionCount": 12
  //   },
  //   {
  //     "survey": {
  //       "id": 8872,
  //       "uuid": null,
  //       "name": "C-10250 | Project GN1 Pack | Soap Pack Test",
  //       "api_survey_id": 8842,
  //       "misc_property": null,
  //       "login_user_id": 1,
  //       "status": 0,
  //       "createdAt": "2022-01-06T12:30:52.000Z",
  //       "updatedAt": "2022-01-06T12:30:52.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "Crownit",
  //       "projectName": null,
  //       "studyName": null,
  //       "orgName": null,
  //       "updateBy": null
  //     },
  //     "dateCreated": "06-Jan-2022",
  //     "responseCount": 0,
  //     "questionCount": 22
  //   },
  //   {
  //     "survey": {
  //       "id": 8871,
  //       "uuid": null,
  //       "name": "Plantet - Kantar",
  //       "api_survey_id": 8841,
  //       "misc_property": "{\"client\":\"Hindustan Thompson Associates Private Limited(Kantar)\",\"category\":\"alcoholic_beverages\",\"research_type\":\"brand_track\",\"account_type\":\"Agency\",\"river_pct\":\"20\",\"panel_pct\":\"80\",\"paid\":\"paid\",\"study_type\":\"Brand_Performance\",\"study_sub_type\":\"Brand_Dip\",\"pm\":\"Ajitesh Pal Singh\",\"ss\":\"2900\",\"cpi\":\"330\",\"deadline\":\"2022-01-21\",\"crm_id\":\"C-9572\",\"loi\":\"20\",\"study_execution_type\":\"\",\"survey_type\":\"2\",\"page_number\":\"0\",\"page_text\":\"\",\"state_targeting\":\"1\",\"study_mode\":\"quant\",\"no_of_interviews\":\"\",\"smart_comm\":\"0\",\"pixel\":\"1\",\"recruiter_restart\":\"0\",\"show_overlay\":\"no-overlay\",\"overlay_position\":\"top-left\",\"agency_pixel\":\"0\",\"referral_reward_limit\":\"500\",\"delayed_terminate\":\"0\",\"delayed_category\":\"0\",\"red_user_state\":0,\"user_restriction\":{\"study_type\":{\"element\":[\"MQ\"],\"days\":\"1\"}},\"rer_block_survey_on\":[],\"ip_restrictions\":1,\"mq_restrict\":\"1\",\"allowed_referral_count\":2,\"fingure_print_check\":1,\"survey_time\":21,\"time_breakup\":{\"243760\":1,\"243761\":3,\"243762\":1,\"243763\":3,\"243764\":1,\"243765\":3,\"243766\":6,\"243767\":1,\"243768\":1,\"243769\":1},\"cookies_days\":\"365\",\"cookies_time\":\"1\",\"entry_days\":\"365\",\"language\":0,\"paytm_check\":\"1\",\"paytm_check_interval\":\"1\",\"survey_ids\":\"8841\",\"callback_url_status\":\"2\",\"cookies_dates\":\"Invalid date\",\"entry_range\":\"2020/08/26 00:00:00 - 2020/08/27 00:00:59\",\"start_date\":\"2020/08/26 00:00:00 \",\"end_date\":\" 2020/08/27 00:00:59\",\"launch_date\":\"2022-01-07 14:47:23\",\"survey_state\":1}",
  //       "login_user_id": 1552,
  //       "status": 1,
  //       "createdAt": "2022-01-06T11:57:37.000Z",
  //       "updatedAt": "2022-01-06T11:57:53.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "diksha.kundra@crownit.in",
  //       "projectName": "Plantet - Kantar",
  //       "studyName": "Plantet - Kantar",
  //       "orgName": "Kantar",
  //       "updateBy": null
  //     },
  //     "dateCreated": "06-Jan-2022",
  //     "responseCount": 299,
  //     "questionCount": 10
  //   },
  //   {
  //     "survey": {
  //       "id": 8870,
  //       "uuid": null,
  //       "name": "Ignore",
  //       "api_survey_id": 8840,
  //       "misc_property": null,
  //       "login_user_id": 1552,
  //       "status": 0,
  //       "createdAt": "2022-01-06T11:44:10.000Z",
  //       "updatedAt": "2022-01-06T11:44:35.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "diksha.kundra@crownit.in",
  //       "projectName": null,
  //       "studyName": null,
  //       "orgName": null,
  //       "updateBy": null
  //     },
  //     "dateCreated": "06-Jan-2022",
  //     "responseCount": 0,
  //     "questionCount": 9
  //   },
  //   {
  //     "survey": {
  //       "id": 8869,
  //       "uuid": null,
  //       "name": "Perfume_Incidence",
  //       "api_survey_id": 8839,
  //       "misc_property": "{\"client\":\"Internal- Crownit\",\"category\":\"personal_care_products\",\"research_type\":\"incidence_check\",\"account_type\":\"Brand\",\"river_pct\":\"0\",\"panel_pct\":\"100\",\"paid\":\"paid\",\"study_type\":\"Shopper_Insights\",\"study_sub_type\":\"Usage_Attitude\",\"pm\":\"Niyati\",\"ss\":\"200\",\"cpi\":\"0\",\"deadline\":\"2022-01-08\",\"crm_id\":\"C-10288\",\"loi\":\"\",\"study_execution_type\":\"\",\"survey_type\":\"3\",\"page_number\":\"0\",\"page_text\":\"\",\"state_targeting\":\"1\",\"study_mode\":\"quant\",\"no_of_interviews\":\"\",\"smart_comm\":\"0\",\"pixel\":\"0\",\"recruiter_restart\":\"0\",\"show_overlay\":\"only-on-top\",\"overlay_position\":\"top-left\",\"agency_pixel\":\"0\",\"referral_reward_limit\":\"500\",\"delayed_terminate\":\"0\",\"delayed_category\":\"0\",\"red_user_state\":0,\"user_restriction\":\"\",\"rer_block_survey_on\":[],\"launch_date\":\"2022-01-06 19:42:58\",\"survey_state\":2,\"survey_time\":30,\"time_breakup\":{\"243709\":1,\"243710\":1,\"243711\":3,\"243712\":6,\"243713\":1,\"243714\":1,\"243719\":4,\"243753\":1,\"243758\":6,\"243759\":6},\"cookies_days\":\"365\",\"cookies_time\":\"1\",\"entry_days\":\"365\",\"language\":0,\"paytm_check\":\"1\",\"paytm_check_interval\":\"1\",\"survey_ids\":\"8839\",\"callback_url_status\":\"2\"}",
  //       "login_user_id": 215,
  //       "status": 0,
  //       "createdAt": "2022-01-06T10:54:49.000Z",
  //       "updatedAt": "2022-01-06T10:54:49.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "niyati.sood@crownit.in",
  //       "projectName": "Perfume_Incidence",
  //       "studyName": "Perfume_Incidence",
  //       "orgName": "Crownit",
  //       "updateBy": null
  //     },
  //     "dateCreated": "06-Jan-2022",
  //     "responseCount": 385,
  //     "questionCount": 10
  //   },
  //   {
  //     "survey": {
  //       "id": 8868,
  //       "uuid": null,
  //       "name": "Project Topaz | 105408720 - RTS0921120 || C-9167_EIN",
  //       "api_survey_id": 8838,
  //       "misc_property": "{\"client\":\"Hindustan Thompson Associates Private Limited(Kantar)\",\"category\":\"shampoo\",\"research_type\":\"Link\",\"account_type\":\"Agency\",\"river_pct\":\"20\",\"panel_pct\":\"80\",\"paid\":\"paid\",\"study_type\":\"Marketing_Communication_Evaluation\",\"study_sub_type\":\"Campaign_Evaluation\",\"pm\":\"Ajitesh Pal Singh\",\"ss\":\"300\",\"cpi\":\"371\",\"deadline\":\"2022-01-15\",\"crm_id\":\"C-9167\",\"loi\":\"25\",\"study_execution_type\":\"\",\"survey_time\":119,\"time_breakup\":{\"243661\":1,\"243663\":3,\"243664\":1,\"243669\":1,\"243670\":1,\"243671\":1,\"243672\":1,\"243673\":1,\"243674\":1,\"243675\":1,\"243676\":1,\"243679\":1,\"243682\":1,\"243683\":1,\"243684\":3,\"243688\":1,\"243689\":7,\"243690\":1,\"243698\":1,\"243699\":1,\"243700\":6,\"243701\":1,\"243702\":1,\"243703\":4,\"243704\":1,\"243705\":1,\"243706\":5,\"243707\":1,\"243708\":7,\"243715\":1,\"243716\":1,\"243717\":1,\"243720\":1,\"243723\":10,\"243724\":1,\"243727\":1,\"243729\":1,\"243730\":1,\"243731\":1,\"243732\":1,\"243733\":1,\"243735\":6,\"243736\":8,\"243749\":8,\"243750\":1,\"243751\":1,\"243752\":1,\"243754\":1,\"243755\":3,\"243756\":1,\"243757\":9,\"243835\":1,\"243836\":1},\"cookies_days\":\"365\",\"cookies_time\":\"2\",\"entry_days\":\"365\",\"language\":0,\"paytm_check\":\"2\",\"paytm_check_interval\":\"1\",\"survey_ids\":\"8838\",\"callback_url_status\":\"2\",\"survey_type\":\"2\",\"smart_comm\":0,\"pixel\":\"1\",\"recruiter_restart\":\"0\",\"show_overlay\":\"no-overlay\",\"overlay_position\":\"\",\"cookies_dates\":\"12\\/01\\/2019\",\"entry_range\":\"2020\\/08\\/25 00:00:00 - 2020\\/08\\/26 00:00:59\",\"start_date\":\"2020\\/08\\/25 00:00:00 \",\"end_date\":\" 2020\\/08\\/26 00:00:59\",\"ip_restrictions\":1,\"mq_restrict\":7,\"user_restriction\":{\"study_type\":{\"element\":[\"MQ\"],\"days\":7}},\"allowed_referral_count\":2,\"fingure_print_check\":1,\"launch_date\":\"2022-01-07 15:04:44\",\"survey_state\":1}",
  //       "login_user_id": 1561,
  //       "status": 1,
  //       "createdAt": "2022-01-06T09:58:05.000Z",
  //       "updatedAt": "2022-01-06T10:00:21.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "updesh.pathak@crownit.in",
  //       "projectName": null,
  //       "studyName": null,
  //       "orgName": null,
  //       "updateBy": null
  //     },
  //     "dateCreated": "06-Jan-2022",
  //     "responseCount": 28,
  //     "questionCount": 53
  //   },
  //   {
  //     "survey": {
  //       "id": 8867,
  //       "uuid": null,
  //       "name": "Fans study short qnr",
  //       "api_survey_id": 8837,
  //       "misc_property": "{\"client\":\"Internal- Crownit\",\"category\":\"skin_creams\",\"research_type\":\"incidence_check\",\"account_type\":\"Brand\",\"river_pct\":\"10\",\"panel_pct\":\"90\",\"paid\":\"unpaid\",\"study_type\":\"Shopper_Insights\",\"study_sub_type\":\"Incidence\",\"pm\":\"Sanyukta sachdeva\",\"ss\":\"0\",\"cpi\":\"0\",\"deadline\":\"2022-01-20\",\"crm_id\":\"C-10259\",\"loi\":\"45\",\"study_execution_type\":\"\",\"survey_type\":\"1\",\"page_number\":\"0\",\"page_text\":\"\",\"state_targeting\":\"0\",\"study_mode\":\"qual\",\"no_of_interviews\":\"\",\"smart_comm\":\"0\",\"pixel\":\"0\",\"recruiter_restart\":\"0\",\"show_overlay\":\"only-on-top\",\"overlay_position\":\"top-left\",\"agency_pixel\":\"0\",\"referral_reward_limit\":\"500\",\"delayed_terminate\":\"0\",\"delayed_category\":\"0\",\"red_user_state\":0,\"user_restriction\":{\"study_type\":{\"element\":[\"RQ\"],\"days\":\"7\"}},\"rer_block_survey_on\":[],\"cookies_days\":\"365\",\"cookies_time\":\"1\",\"entry_days\":\"365\",\"language\":0,\"paytm_check\":\"1\",\"paytm_check_interval\":\"1\",\"survey_ids\":\"8837\",\"callback_url_status\":\"2\",\"survey_time\":28,\"time_breakup\":{\"243637\":1,\"243638\":3,\"243639\":6,\"243640\":1,\"243641\":1,\"243642\":1,\"243718\":4,\"243722\":2,\"243734\":1,\"243737\":1,\"243738\":3,\"243748\":4},\"launch_date\":\"2022-01-06 17:22:02\",\"survey_state\":1}",
  //       "login_user_id": 1570,
  //       "status": 1,
  //       "createdAt": "2022-01-06T08:45:19.000Z",
  //       "updatedAt": "2022-01-06T08:45:19.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "sanyukta.sachdeva@crownit.in",
  //       "projectName": "Fans study short qnr",
  //       "studyName": "Fans study short qnr",
  //       "orgName": "Crownit",
  //       "updateBy": null
  //     },
  //     "dateCreated": "06-Jan-2022",
  //     "responseCount": 219,
  //     "questionCount": 12
  //   },
  //   {
  //     "survey": {
  //       "id": 8866,
  //       "uuid": null,
  //       "name": "LGT Chennai -  Mandate",
  //       "api_survey_id": 8836,
  //       "misc_property": "{\"client\":\"Hindustan Thompson Associates Private Limited(Kantar)\",\"category\":\"FMCG\",\"research_type\":\"Link\",\"account_type\":\"Agency\",\"river_pct\":\"20.00\",\"panel_pct\":\"80.00\",\"paid\":\"paid\",\"study_type\":\"Marketing_Communication_Evaluation\",\"study_sub_type\":\"Campaign_Evaluation\",\"pm\":\"Ajitesh Pal Singh\",\"ss\":\"90\",\"cpi\":\"263.00000000\",\"deadline\":\"2022-01-09\",\"crm_id\":\"C-10281\",\"loi\":\"15\",\"study_execution_type\":\"\",\"survey_time\":13,\"time_breakup\":{\"243592\":1,\"243593\":3,\"243594\":1,\"243595\":3,\"243596\":1,\"243597\":3,\"243598\":1},\"cookies_days\":\"365\",\"cookies_time\":\"1\",\"entry_days\":\"365\",\"language\":0,\"paytm_check\":\"1\",\"paytm_check_interval\":\"1\",\"survey_ids\":\"8835,8836\",\"callback_url_status\":\"2\",\"survey_type\":\"2\",\"smart_comm\":\"0\",\"pixel\":\"1\",\"recruiter_restart\":\"0\",\"show_overlay\":\"no-overlay\",\"overlay_position\":\"top-left\",\"cookies_dates\":\"Invalid date\",\"entry_range\":\"2020/08/25 00:00:00 - 2020/08/26 00:00:59\",\"start_date\":\"2020/08/25 00:00:00 \",\"end_date\":\" 2020/08/26 00:00:59\",\"user_restriction\":{\"study_type\":{\"element\":[\"MQ\"],\"days\":\"-1\"},\"research_type\":{\"element\":[\"Link\"],\"days\":\"-1\"}},\"ip_restrictions\":1,\"mq_restrict\":\"-1\",\"allowed_referral_count\":2,\"fingure_print_check\":1,\"launch_date\":\"2022-01-06 17:07:11\",\"survey_state\":1,\"page_number\":\"0\",\"page_text\":\"\",\"state_targeting\":\"1\",\"study_mode\":\"quant\",\"no_of_interviews\":\"\",\"agency_pixel\":\"0\",\"referral_reward_limit\":\"500\",\"delayed_terminate\":\"0\",\"delayed_category\":\"0\",\"red_user_state\":2,\"rer_block_survey_on\":[]}",
  //       "login_user_id": 1552,
  //       "status": 1,
  //       "createdAt": "2022-01-06T07:54:35.000Z",
  //       "updatedAt": "2022-01-06T07:54:55.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "diksha.kundra@crownit.in",
  //       "projectName": "LGT CHENNAI - MANDATE",
  //       "studyName": "LGT CHENNAI - MANDATE",
  //       "orgName": "Kantar",
  //       "updateBy": null
  //     },
  //     "dateCreated": "06-Jan-2022",
  //     "responseCount": 15,
  //     "questionCount": 7
  //   },
  //   {
  //     "survey": {
  //       "id": 8865,
  //       "uuid": null,
  //       "name": "LGT Chennai- Non Mandate",
  //       "api_survey_id": 8835,
  //       "misc_property": "{\"client\":\"Hindustan Thompson Associates Private Limited(Kantar)\",\"category\":\"FMCG\",\"research_type\":\"Link\",\"account_type\":\"Agency\",\"river_pct\":\"20\",\"panel_pct\":\"80\",\"paid\":\"paid\",\"study_type\":\"Marketing_Communication_Evaluation\",\"study_sub_type\":\"Campaign_Evaluation\",\"pm\":\"Ajitesh Pal Singh\",\"ss\":\"90\",\"cpi\":\"183\",\"deadline\":\"2022-01-09\",\"crm_id\":\"C-10176\",\"loi\":\"15\",\"study_execution_type\":\"\",\"survey_time\":13,\"time_breakup\":{\"243585\":1,\"243586\":3,\"243587\":1,\"243588\":3,\"243589\":1,\"243590\":3,\"243591\":1},\"cookies_days\":\"365\",\"cookies_time\":\"1\",\"entry_days\":\"365\",\"language\":0,\"paytm_check\":\"1\",\"paytm_check_interval\":\"1\",\"survey_ids\":\"8835,8836\",\"callback_url_status\":\"2\",\"survey_type\":\"2\",\"smart_comm\":\"0\",\"pixel\":\"1\",\"recruiter_restart\":\"0\",\"show_overlay\":\"no-overlay\",\"overlay_position\":\"top-left\",\"cookies_dates\":\"Invalid date\",\"entry_range\":\"2020/08/26 00:00:00 - 2020/08/27 00:00:59\",\"start_date\":\"2020/08/26 00:00:00 \",\"end_date\":\" 2020/08/27 00:00:59\",\"user_restriction\":{\"study_type\":{\"element\":[\"MQ\"],\"days\":\"-1\"},\"research_type\":{\"element\":[\"Link\"],\"days\":\"-1\"}},\"ip_restrictions\":1,\"mq_restrict\":\"-1\",\"allowed_referral_count\":2,\"fingure_print_check\":1,\"launch_date\":\"2022-01-06 17:05:35\",\"survey_state\":1,\"page_number\":\"0\",\"page_text\":\"\",\"state_targeting\":\"1\",\"study_mode\":\"quant\",\"no_of_interviews\":\"\",\"agency_pixel\":\"0\",\"referral_reward_limit\":\"500\",\"delayed_terminate\":\"0\",\"delayed_category\":\"0\",\"red_user_state\":2,\"rer_block_survey_on\":[]}",
  //       "login_user_id": 1552,
  //       "status": 1,
  //       "createdAt": "2022-01-06T07:52:09.000Z",
  //       "updatedAt": "2022-01-06T07:52:35.000Z",
  //       "repo_description": null,
  //       "repo_type": null,
  //       "repo_tags": null,
  //       "type": 1,
  //       "createdBy": "diksha.kundra@crownit.in",
  //       "projectName": "LGT CHENNAI- NON MANDATE",
  //       "studyName": "LGT CHENNAI- NON MANDATE",
  //       "orgName": "Kantar",
  //       "updateBy": null
  //     },
  //     "dateCreated": "06-Jan-2022",
  //     "responseCount": 85,
  //     "questionCount": 7
  //   }
  // ]

  constructor(private stydiesService:StudiesService,
    private notifier: NotifierService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private surveyService: surveyPanelService,
    private logerror: LoginService,
    public notification: NotifierService) {
      this.surveyList = [];
      this.accessRole = JSON.parse(localStorage.getItem('access'));
     }

  ngOnInit() {
    this.activatedRoute.params.subscribe((ID) => { this.projectId = ID.id; });
    this.loadsurvey();
    // this.filteredOptions = this.survey_id.valueChanges.pipe(
    //   startWith(''),
    //   debounceTime(400),
    //   distinctUntilChanged(),
    //   map(value => this._filter(value)),
    // );
    
  }

  // private _filter(value: string): string[] {
  //   this.loadsurvey();
  //   const filterValue = value.toLowerCase();
  //   this.search = value;
  //   return this.surveyList.filter(option => option['survey']['name'].toLowerCase().includes(filterValue));
  // }

  onTextChange(search){
    this.search = search.toLowerCase();
    if (this.search.length>2) {
      this.loadsurvey();
    }
  }

  ngOnDestroy(){
    this.hideOldestNotification();
  }

  onCreate(){
    this.createStudy();

  }
  onClose(){
    this.updateStudy.emit(false);
  }

  public showNotification( type: string, message: string ): void {
		this.notifier.notify( type, message );
	}

	public hideOldestNotification(): void {
		this.notifier.hideOldest();
	}

  
  createStudy(){
    let dataStudy = {
      name: this.studyName.value,
      project_id: this.projectId,
      status: '1',
      // study_type:this.studytype ,
      survey_id:this.surveyList.find(item =>{return item['survey']['name'] === this.survey_id.value})['survey'].uuid
    };

  //   debugger
  //  console.log(dataStudy);

    this.stydiesService.createStudy(dataStudy).subscribe(
      (data)=>{
        if(data['status']===1){
          this.updateStudy.emit(true);
          this.showNotification('success', data['message']);
          this.onClose();
        }else{
          this.showNotification('error', data['message']);
        }
      },
      (error)=>{
        if (error.status === 403) {
          this.router.navigate(['home/access-denied']);
        }
        else if (error.status === 401) {
          this.showNotification('error', 'User is not authorised');
        }
        else {
          this.showNotification('error', 'Something went wrong');
        }
      }
    );
  }

  loadsurvey() {
    const sdata = {"limit":24,"search": this.search };
    // debugger
    this.surveyList = [];
    this.surveyService.getAllServeys(sdata).subscribe(data => {
      if (data['errorMessage'] == "") {

        data['result'].forEach(element => {
          this.surveyList.push(element);
        });   

        if (this.search != '') {
          setTimeout(() =>{
            this.filteredSurveyList = this.surveyList.filter(option => (option['survey']['name'].toLowerCase().includes(this.search)) || (option['survey']['api_survey_id'].toString().includes(this.search)));
          },200)
        }else{
          this.filteredSurveyList = this.surveyList.filter(option => true);
        }
      }else{
        this.notification.notify("info", "NO data found!");
      }
    },error =>{
      if(error.status == 401){
        this.notification.notify("error", "User is not authorised");
        this.router.navigate(['home/access-denied']);
      }else{
        this.notification.notify("error", "Something went wrong!");
      }
    });
  }

}
